<template>
    <b-modal id="modalFornec" v-model="showFornec" centered>
        <template #modal-title>
            {{$t('Para qual fornecedor você deseja enviar esta OS?')}}
        </template>
        <v-select :options="getFornecedores" v-model="fornecedores" :placeholder="$t('Fornecedor')"></v-select>
        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalFornec')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="$emit('saveFornec', os.nr_sequencial, fornecedores.nr_sequencial)">
                        {{ $t('Vincular Fornecedor') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
export default {
    data() {
        return {
            showFornec: true,
            fornecedores: '',
        }
    },
    props: {
        os: {}
    },
    computed: {
        getFornecedores() {
            const fornecedores = this.$store.getters['filial/fornecedores']

            if (!fornecedores) {
                this.$store.dispatch('filial/getFornecedores')
                return []
            }

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        },
    }
}
</script>
<style>
#modalFornec{
  pointer-events: none!important;
}
.close{
    display: none!important;
}
</style>